jQuery(document).ready(function () {
    $('.mg').show();
    $('.uk-form').show();
    $('.formsProp').remove();
    $('.fm-editOption').remove();
    $('a[cmd="edit"]').remove();
    $('.thankForm').hide();
    // External form
    $('.uk-form').each(function () {
        if ($(this).find('#form-typeSubmit').val() == '1') {
            $(this).find('[name_external]').each(function () {
                var nameEX = $(this).attr('name_external');
                if (nameEX) {
                    $(this).attr('name', nameEX);
                }
            });
        }

    })

    $('.uk-form[class*="rv-form"]').on('submit', function () {

        //if ($(this).closest("form").valid() == false) {
        if ($(this).valid() == false) {
            return false;
        }

        $('body').css('overflow', 'hidden');
        var overlayfrontend = $('<div class="overlayfrontend">' + '<div class="loading">' + '<img src="' + mex.url.rvsThemImage + '/images/email-loading.svg" width="150" height="250" border="0" align="absmiddle" />' + '<h1 class="loadingCount" style="color:#fff;"></h1>' + '<h2><font color="#ffffff">Email sending...' + '<br>Please do not close or refresh this page.</font></h2></div>' + '</div>').css({
            width: $('body').width(),
            height: $('body').height()
        });

        $('body').prepend(overlayfrontend);

        //var formName = $(this).closest('form').attr('name')

        //TODO: get form setting by form_id

        //form_settings[]

        //alert(formName);
        //alert('somone clicke me');

        //var formData = $(this).closest("form").serializeJSON();
        var form = $(this).closest('form');
        var formData = getFormData(form);


        var form_action = mex.url.routeFormajaxSubmit;
        formData['_token'] = $('meta[name="csrf-token"]').attr('content');

        var frmAttrId = $(this).get(0).id; //  element form
        formData['frmAttrId'] = frmAttrId;
        formData['pageId'] = mex.page_id;
        //alert(formData['pageId']);
        //alert(formData['frmAttrId']);

        //alert(form_settings[frmAttrId]['action_type']);
        if (form_settings[frmAttrId]['action_type'] == '1') {
            form_action = form_settings[frmAttrId]['external_url'];
            //alert('External post to ' + form_action);
            //form.submit();
        } else {
            //alert(form_action);
            $.ajax({
                type: 'POST',
                url: form_action,
                data: formData,
                success: function (data) {
                    //TODO show form success div
                    if (!data.errors) {
                        //alert(data.msg);
                        var mg = form.closest('.mg');
                        var editable = mg.closest('.editable_area');
                        editable.find('.mg').hide();
                        form.hide();
                        mg.show();
                        mg.find('.thankForm').show();
                        $('body').css('overflow', 'auto');
                        $('.overlayfrontend').remove();
                    }

                    return;
                },
                error: function (xhr, ajaxOptions, thrownError) {
                    $('body').css('overflow', 'auto');
                    $('.overlayfrontend').remove();
                    console.pop.error({
                        text: thrownError
                    });

                    return;
                },
            });
            //form not redirect with submit button
            return false;
        }
    });
});

function getFormData($form) {
    var unindexed_array = $form.serializeArray();
    var indexed_array = {};

    $.map(unindexed_array, function (n, i) {
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}
